export interface iGlobalUserData {
    hasFFChainsEnableLoginPermission: boolean;
    hasFFChainsFeaturePermission: boolean;
    hasMacAdminAccess: boolean;
}

export default class GlobalUserData implements iGlobalUserData{
    hasFFChainsEnableLoginPermission= false;
    hasFFChainsFeaturePermission: boolean = false;
    hasMacAdminAccess: boolean = false;

    constructor(pageData?: any | null) {
        if (pageData) {
            this.hasFFChainsEnableLoginPermission = pageData?.hasSnapFeaturesProduct || false;
            this.hasFFChainsFeaturePermission = pageData?.hasSnapFeaturesFfChains || false;
            this.hasMacAdminAccess = pageData?.hasMacAdminAccess || false;
        }
    }
}